import { render, staticRenderFns } from "./CustomerCaseModal.vue?vue&type=template&id=7518ecc9&"
import script from "./CustomerCaseModal.vue?vue&type=script&lang=js&"
export * from "./CustomerCaseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports